import Box from '@mui/material/Box';
import { BiSortDown } from '@react-icons/all-files/bi/BiSortDown';
import { BiSortUp } from '@react-icons/all-files/bi/BiSortUp';
import { flexRender, Header } from '@tanstack/react-table';

import { ThStyled } from '../../styles';
import { TableLayoutHelper } from '../../core/table-layout-helper';
import { Tooltip } from '../../../tooltip';

interface Props {
  header: Header<any, unknown>;
  variant?: 'table' | 'list' | undefined;
  backgroundColor?: string;
  textColor?: string;
  table: any;
}

export function CellHeaderRender({
  header,
  variant,
  backgroundColor,
  textColor,
  table,
}: Props) {
  const canSort = (header.column.columnDef?.meta as any)?.canSort;
  const tooltip = (header.column.columnDef?.meta as any)?.tooltip;

  return (
    <ThStyled
      variant={variant}
      key={header.id}
      onClick={canSort && header.column.getToggleSortingHandler()}
      style={TableLayoutHelper.getHeaderStyles({
        header,
        backgroundColor,
        textColor,
        columnSizingInfo: table.getState().columnSizingInfo,
      })}
    >
      <Box
        style={TableLayoutHelper.getHeaderContentStyles({
          header,
        })}
      >
        {header.isPlaceholder
          ? null
          : flexRender(header.column.columnDef.header, header.getContext())}

        {header.column.getIsSorted() && (
          <Box height={12}>
            {
              {
                asc: <BiSortUp color="#fff" />,
                desc: <BiSortDown color="#fff" />,
              }[header.column.getIsSorted() as string]
            }
          </Box>
        )}

        {tooltip && <Tooltip text={tooltip} size={14} />}
      </Box>
    </ThStyled>
  );
}
